const getNow = () => {
  if ('performance' in global && 'now' in global.performance) {
    return global.performance.now();
  }

  return Date.now();
};

export default getNow;
